import { Button, Container, Form, FormGroup, Modal } from "react-bootstrap"
import DataTable from "react-data-table-component"
import * as XLSX from "xlsx";
import { IoHomeOutline } from "react-icons/io5"
import { FaPlus } from "react-icons/fa6"
import React, { useState } from "react"
import { useEffect } from "react"
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai"
import Swal from "sweetalert2"
import { CreateProduct, DeleteProduct, GetAllProducts, GetAllProductsCategory, GiftAvailableByName, UpdateProduct,GetProductByIsGift, CreateExcelGifts, ProductAvailableByName } from "../../utils/proxy/ProductsProxy"
import { Op_per } from "../../utils/Permissions"
import Select from "react-select"
import LoadingComponent from "../Includes/LoadingComponent"
import { GetAllCurrency } from "../../utils/proxy/Currencyproxy"
import { RiFileExcel2Fill } from "react-icons/ri"
import { HiDotsVertical } from "react-icons/hi"

const GiftMaster = () => {
const [data, setData] = useState([]);
    const [id, setId] = useState();
    const [name, setName] = useState();
    const [description, setDescription] = useState();
    const [allCategory, setAllCategory] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const [selectedCategoryId, setSelectedCategoryId] = useState(null);
    const [allCurrency, setAllCurrency] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState();
    const [selectedCurrencyId, setSelectedCurrencyId] = useState();
    const [price, setPrice] = useState();
    const [salePrice, setSalePrice] = useState();
    const [quantity, setQuantity] = useState();
    const [filterdata, setFilterData] = useState([]);
    const [searchQuery, setSearchQuery] = useState('');

        const [fileUploaded, setFileUploaded] = useState(false);
        const [excelData, setExcelData] = useState([]);
        const [columnTitles, setColumnTitles] = useState({
        title1: excelData.length > 0 ? Object.keys(excelData[0])[0] : "",
        title2: excelData.length > 0 ? Object.keys(excelData[0])[1] : "",
        title3: excelData.length > 0 ? Object.keys(excelData[0])[2] : "",
        title4: excelData.length > 0 ? Object.keys(excelData[0])[3] : "",
        title5: excelData.length > 0 ? Object.keys(excelData[0])[4] : "",
        title6: excelData.length > 0 ? Object.keys(excelData[0])[5] : "",
        });
        const [showuploader, setShowUploader] = useState(false);
    
      const handleUploaderShow = () => setShowUploader(true);
      const handleUploaderClose = () => setShowUploader(false);

    const [reload, SetReload] = useState(false);
    const [show, setShow] = useState(false);
    const [available, setAvailable] = useState(true);
    const [operation, setOperation] = useState('Add');
    const [loading, setLoading] = useState(true);


        const filteredData = data.filter((k) =>
        (k.name && k.name.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (k.description && k.description.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (k.categoryname && k.categoryname.toLowerCase().includes(searchQuery.toLowerCase())) ||
        (k.currency && k.currency.toLowerCase().includes(searchQuery.toLowerCase()))
    );

        const handleSearchQuery = (e) => {
        setSearchQuery(e);
    }


    useEffect(() => {
        const getall = async () => {
            let d = await GetProductByIsGift(true);
            if (d) {
                setData(d);
                setFilterData(d);
            } else {
                alert('Error', 'Issues while fetching data')
            }
        }
        getall()
        SetReload(false);
    }, [reload])

    useEffect(()=>{
        const getcategories = async () =>{
            let d = await GetAllProductsCategory();
            if(d){
                setAllCategory(d);
            }else{
                alert('Error', 'Issues while fetching Categories')
            }
        }

        const getcurrencies = async () =>{
            let d = await GetAllCurrency();
            if(d){
                setAllCurrency(d);
            }else{
                alert('Error', 'Issues while fetching Currency')
            }
        }

        getcategories();
        getcurrencies();
    },[])


    useEffect(() => {
        let debounceTimeout;
      
        if (name !== "" && name !== null && name !== undefined) {
          debounceTimeout = setTimeout(async () => {
            // Make API call with name
            const a = await ProductAvailableByName(name);
            const b = await GiftAvailableByName(name);

            setAvailable(a&b);
          }, 500); // Adjust debounce delay as needed
        }else{
            setAvailable(true);
        }
      
        // Clear timeout when name changes or becomes empty
        return () => clearTimeout(debounceTimeout);
      }, [name]);



//   useEffect(() => {
//     SetReload(true);

//     if (filterbyCondition === Filters[0]) {
//         setData(filterdata);
//     } else if (filterbyCondition === Filters[1]) {
//         const isGift = filterdata.filter(
//             (item) => item.gift === true || item.gift === "true"
//         );
//         setData(isGift);
//     } else if (filterbyCondition === Filters[2]) {
//         const isNotGift = filterdata.filter(
//             (item) => item.gift === false || item.gift === "false"
//         );
//         setData(isNotGift);
//     } else {
//         setData(filterdata);
//     }

//     SetReload(false);
// }, [reload, filterbyCondition, filterdata]);

    

    const handleShow = () => {
        setShow(true);
    }

    const handledelete = async (id) => {
        let d = await DeleteProduct(id);
        if (d.status === 'success') {
            SetReload(true);
            Swal.fire({
                title: "Success!",
                text: "Gift Deleted !!",
                icon: "success",
                confirmButtonText: "OK",
            });
        }
    }

    const handleEditShow = (row) => {
        setShow(true);
        setOperation('Edit')
        setId(row.id);
        setName(row.name);
        setDescription(row.description);
        setSelectedCategory({ value: row.categoryid, label: row.categoryname })
        setSelectedCategoryId(row.categoryid);
        setSelectedCurrency({value: row.currencyid, label: row.currencyname})
        setSelectedCurrencyId(row.currencyid);
        setPrice(row.price);
        setSalePrice(row.saleprice);
        setQuantity(row.quantity)
    }

    const handleClose = () => {
        setShow(false)
        setAvailable(true);
        setId(null);
        setName(null);
        setDescription(null);
        setSelectedCategory(null);
        setSelectedCategoryId(null);
        setSelectedCurrency();
        setSelectedCurrencyId();
        setPrice();
        setSalePrice();
        setQuantity();
        setOperation('Add')
    }

    const handleNameChange = (e) => {
        const { value } = e.target
        setName(value);
    }

    const category = [];
    const currency = [];

    allCategory.map((cat) => {
        category.push({
            value: cat.id,
            label: cat.name
        })
    })

    allCurrency.map((curr)=>{
        currency.push({
            value: curr.id,
            label: curr.currency
        })
    })

    const handleCategoryChange = (selected) => {
        if (selected === null) {
            setSelectedCategory();
            setSelectedCategoryId();
        } else {
            setSelectedCategory(selected);
            setSelectedCategoryId(selected.value);
        }

    }

    const handleCurrencyChange = (selected) => {
        if (selected === null) {
            setSelectedCurrency();
            setSelectedCurrencyId();
        } else {
            setSelectedCurrency(selected);
            setSelectedCurrencyId(selected.value);
        }

    }

    const handleSave = async () => {
        if (name == null || name == '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Gift Name !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(selectedCategoryId == null || selectedCategoryId == ''){
            Swal.fire({
                title: "Warning!",
                text: "Select Gift Category !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(selectedCurrencyId == null || selectedCurrencyId == ''){
            Swal.fire({
                title: "Warning!",
                text: "Select Currency !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(price == null || price <= 0){
            Swal.fire({
                title: "Warning!",
                text: "Enter Appropriate Price !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(salePrice == null || salePrice <= 0){
            Swal.fire({
                title: "Warning!",
                text: "Enter Appropriate Sale Price !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(quantity == null || quantity < 0){
            Swal.fire({
                title: "Warning!",
                text: "Enter Appropriate Quantity !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            setLoading(false)
            let d = await CreateProduct(name, description,selectedCategoryId,selectedCurrencyId,price,salePrice,quantity,true,"");
            if (d.status === 'success') {
                setShow(false);
                SetReload(true);
                setName(null);
                setDescription(null);
                setSelectedCategory();
                setSelectedCategoryId();
                setSelectedCurrency();
                setSelectedCurrencyId();
                setPrice();
                setSalePrice();
                setQuantity();
                setLoading(true)
                Swal.fire({
                    title: "Success!",
                    text: "New Gift Added !!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } else if (d.status === 'error') {
                setLoading(true)
                Swal.fire({
                    title: "Warning!",
                    text: d.message,
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            } else{
                setLoading(true)
                Swal.fire({
                    title: "Warning!",
                    text: "Something Went Wrong!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const handleEditSave = async () => {
        if (name == null || name === '') {
            Swal.fire({
                title: "Warning!",
                text: "Enter Gift Name !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(selectedCategoryId == null || selectedCategoryId === ''){
            Swal.fire({
                title: "Warning!",
                text: "Select Gift Category !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(selectedCurrencyId == null || selectedCurrencyId === ''){
            Swal.fire({
                title: "Warning!",
                text: "Select Currency !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(price == null || price <= 0){
            Swal.fire({
                title: "Warning!",
                text: "Enter Appropriate Price !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(salePrice == null || salePrice <= 0){
            Swal.fire({
                title: "Warning!",
                text: "Enter Appropriate Sale Price !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else if(quantity == null || quantity < 0){
            Swal.fire({
                title: "Warning!",
                text: "Enter Appropriate Quantity !!",
                icon: "warning",
                confirmButtonText: "OK",
            });
        } else {
            setLoading(false)
            
            let d = await UpdateProduct(id, name, description, selectedCategoryId,selectedCurrencyId,price,salePrice,quantity,true,"");
            if (d && d.status === 'success') {
                setShow(false);
                setOperation('Add')
                SetReload(true);
                setId(null);
                setName(null);
                setDescription(null);
                setSelectedCategory();
                setSelectedCategoryId();
                setSelectedCurrency();
                setSelectedCurrencyId();
                setPrice();
                setSalePrice();
                setQuantity();
                setLoading(true)
                Swal.fire({
                    title: "Success!",
                    text: "Gift Detail Edited !!",
                    icon: "success",
                    confirmButtonText: "OK",
                });
            } else{
                setLoading(true)
                Swal.fire({
                    title: "Warning!",
                    text: "Something Went Wrong!",
                    icon: "warning",
                    confirmButtonText: "OK",
                });
            }
        }
    }

    const columns = [
        // {
        //     name: "Id",
        //     selector: (row) => row.id,
        //   
        
        // },
        {
            name: "Gift Name",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.name === "" || row.name === null ? "#f36e6f" : "", borderRadius: "10px", border: row.name === "" || row.name === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.name === "" || row.name === null ? "#fff" : "#000", margin: "3px", }}>{row.name ? row.name : "N/A"}</div>,
            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Description",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.description === "" || row.description === null ? "#f36e6f" : "", borderRadius: "10px", border: row.description === "" || row.description === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.description === "" || row.description === null ? "#fff" : "#000", margin: "3px", }}>{row.description ? row.description : "N/A"}</div>,
            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Price",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.price === "" || row.price === null ? "#f36e6f" : "", borderRadius: "10px", border: row.price === "" || row.price === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.price === "" || row.price === null ? "#fff" : "#000", margin: "3px", }}>{row.price ? <span>{row.currency} {row.price}</span> : "N/A"}</div>,
            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Sale Price",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.saleprice === "" || row.saleprice === null ? "#f36e6f" : "", borderRadius: "10px", border: row.saleprice === "" || row.saleprice === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.saleprice === "" || row.saleprice === null ? "#fff" : "#000", margin: "3px", }}>{row.saleprice ? <span>{row.currency} {row.saleprice}</span> : "N/A"}</div>,
            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Quantity",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.quantity === "" || row.quantity === null ? "#f36e6f" : "", borderRadius: "10px", border: row.quantity === "" || row.quantity === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.quantity === "" || row.quantity === null ? "#fff" : "#000", margin: "3px", }}>{row.quantity ? row.quantity : "N/A"}</div>,
            fontSize: 10,
            fontWeight: 'bold',
        },
        {
            name: "Category",
            selector: (row) => <div style={{ whiteSpace: 'normal', backgroundColor: row.categoryname === "" || row.categoryname === null ? "#f36e6f" : "", borderRadius: "10px", border: row.categoryname === "" || row.categoryname === null ? "2px solid transparent" : "2px solid transparent", padding: "3px", display: "flex", flexDirection: "row", color: row.categoryname === "" || row.categoryname === null ? "#fff" : "#000", margin: "3px", }}>{row.categoryname ? row.categoryname : "N/A"}</div>,
            fontSize: 10,
            fontWeight: 'bold',
        },
    ];

    const CustomHeader = ({ children }) => (<div style={{ backgroundColor: 'blue', padding: '10px', color: 'white' }}>    {children}  </div>);

    if (Op_per.get().GIFTS.ALLOW_DELETE || Op_per.get().GIFTS.ALLOW_EDIT) {
        columns.push({
            name: "Actions",
            selector: (row) => (
                <div key={row.id}>
                    <AiFillDelete
                        onClick={() => handledelete(row.id)}
                        style={{ color: "#f36e6f", fontSize: 20, display: Op_per.get().GIFTS.ALLOW_DELETE ? '' : 'none' }}
                    />
                    &nbsp;&nbsp;&nbsp;
                    <AiTwotoneEdit
                        onClick={() => handleEditShow(row)}
                        style={{ color: "#9889e6", fontSize: 20, display: Op_per.get().GIFTS.ALLOW_EDIT ? '' : 'none' }}
                    />
                </div>
            ),
        })
    }


        const downloadProductCSV = () => {
        if (!filteredData || filteredData.length === 0) {
            Swal.fire({
                title: "No Data!",
                text: "There are no products to export.",
                icon: "info",
                confirmButtonText: "OK",
            });
            return;
        }
    
        const headers = [
            "Gift Name",
            "Description",
            "Price",
            "Sale Price",
            "Quantity",
            "Category",
            "Currency"
        ];
    
        const rows = filteredData.map((item) => [
            item.name || "N/A",
            item.description || "N/A",
            item.price || 0,
            item.saleprice || 0,
            item.quantity || 0,
            item.categoryname || "N/A",
            item.currencyname || "N/A"
        ]);
    
        const csvContent = [
            headers.join(","),
            ...rows.map(row => row.join(","))
        ].join("\n");
    
        const filename = `GiftMaster-${new Date().toISOString().slice(0, 10)}.csv`;
    
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        const url = URL.createObjectURL(blob);
    
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

      const handleTitleChange = (event) => {
        const { name, value } = event.target;
        setColumnTitles({ ...columnTitles, [name]: value });
      };
    
    
    
    
    const handleFileUpload = (event) => {
      const file = event.target.files[0];
      if (!file) return;
    
      const reader = new FileReader();
    
      reader.onload = (event) => {
        const data = new Uint8Array(event.target.result);
        const workbook = XLSX.read(data, { type: "array" });
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];
        const sheetData = XLSX.utils.sheet_to_json(sheet, { defval: "" }); // ensure empty cells aren't undefined
        setExcelData(sheetData);
        setFileUploaded(true);
      };
    
      reader.readAsArrayBuffer(file);
    };
    
    
    const handleAddData = () => {
      if (!excelData || excelData.length === 0) {
        alert("No Excel data available to submit.");
        return;
      }
    
      const newData = excelData.map((row) => {
        return {
          name: row[columnTitles.title1],
          description: row[columnTitles.title2],
          category: row[columnTitles.title3],
          price: row[columnTitles.title4],
          saleprice: row[columnTitles.title5],
          quantity: row[columnTitles.title6],
        };
      });
    
      createExcelGift(newData);
    };
    
      //upload excels
      let createExcelGift = async (jsonData) => {
            setLoading(false);
        let statedata = await CreateExcelGifts(jsonData);
        if (statedata) {
          SetReload(true);
          setLoading(true);
          setShowUploader(false);
    
          Swal.fire({
            title: "Success!",
            text: "Gifts Added Successfully !!",
            icon: "success",
            confirmButtonText: "OK",
          });
        } else {
          alert("Error", "Issue While Fetching Gifts");
        }
      };

    return (
        <Container fluid style={{ minHeight: "80vh" }}>
            <div
                className="glass-body"
                style={{
                    margin: 10,
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    padding: 0,
                    backgroundColor: 'transparent'
                }}
            >

                <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                    <ul id="breadcrumb">
                        <li><a href="/"><IoHomeOutline
                            style={{ color: "white", fontSize: 20 }}
                            
                        /></a></li>
                        <li><a href="/product-master"><span class="icon icon-beaker"> </span>Gift</a></li>
                        <li><a href="/product-master"><span class="icon icon-beaker"> </span>Master</a></li>
                        {/* <li><a href="#"><span class="icon icon-double-angle-right"></span>Doctor</a></li> */}

                    </ul>

                </div>
            </div>
            <div className="glass-body" style={{ margin: 10 }}>
            <div
                style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                }}
                className="flex-column-mobile"
            >

            <div>
                <FormGroup className="">
                        <Form.Control
                        placeholder="Search Gift . . ."
                        value= {searchQuery}
                        onChange={(e) => {handleSearchQuery(e.target.value)}}                                    
                        />
                </FormGroup>
            </div>
                {/* Left side filters
                <div style={{ minWidth: "300px", maxWidth: "350px" }}>
                {Op_per.get().REPORTS_DCR_MONTHLY.USER_DROPDOWN && (
                    <Form.Group className="mb-3" controlId="formIsGift">
                    <div style={{ display: "flex", flexDirection: "row", gap: "20px" }}>
                        <Form.Check
                        type="checkbox"
                        label="All Products"
                        checked={filterbyCondition === Filters[0]}
                        onChange={() => {
                            setFilterByCondition(Filters[0]);
                        }}
                        />
                        <Form.Check
                        type="checkbox"
                        label="Is Gift"
                        checked={filterbyCondition === Filters[1]}
                        onChange={() => {
                            setFilterByCondition(Filters[1]);
                        }}
                        />
                        <Form.Check
                        type="checkbox"
                        label="Is Not Gift"
                        checked={filterbyCondition === Filters[2]}
                        onChange={() => {
                            setFilterByCondition(Filters[2]);
                        }}
                        />
                    </div>
                    </Form.Group>
                )}
                </div> */}

                {/* Add button */}
                <div>
                {Op_per.get().GIFTS.ALLOW_ADD ? (
                                      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    
                                            {/* Dropdown */}
                                            <div className="dropdown">
                                                <button
                                                    className="btn btn-secondary"
                                                    type="button"
                                                    style={{ backgroundColor: "#2194f0" }}
                                                    title="Options"
                                                    id="dropdown-basic"
                                                    data-bs-toggle="dropdown"
                                                    aria-expanded="false"
                                                >
                                                    <HiDotsVertical />
                                                </button>
                                                <ul className="dropdown-menu">
                                                    <li
                                                        onClick={handleShow}
                                                    >
                                                        <a className="dropdown-item">Add</a>
                                                    </li>
                                                    <li
                                                        onClick={handleUploaderShow}
                                                    >
                                                        <a className="dropdown-item">Import XLSX</a>
                                                    </li>
                                                    <li
                                                        onClick={downloadProductCSV}
                                                    >
                                                        <a className="dropdown-item">Export XLSX</a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                ) : (
                    ""
                )}
                </div>
            </div>



            {/* Data Table */}

             {!loading ? (
                      <div style={{ display: "grid", placeContent: "center" }}>
                        <LoadingComponent />
                      </div>
                    ) : (
            <div style={{ marginTop: 10 }}>
                <DataTable
                columns={columns}
                data={filteredData}
                pagination
                customStyles={{
                    headRow: {
                    style: { backgroundColor: "#c0dfff", padding: 7, borderRadius: "10px 10px 0 0" },
                    },
                }}
                CustomHeader={<CustomHeader />}
                dense
                />
            </div>
                    )}
            </div>


            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{operation} Gift</Modal.Title>
                </Modal.Header>
                {loading ? <Modal.Body>
                    <Form>
                        <Form.Group className="mb-3" controlId="formBasicPassword">
                            <Form.Label>Gift Name <span style={{ color: "red" }} >*</span></Form.Label>
                            <Form.Control
                                style={{
                                    height: 40,

                                    borderColor: available ? '#28B3D2' : 'red',
                                    borderWidth: 1,
                                    paddingHorizontal: 8,
                                    marginBottom: 16,
                                    
                                    borderRadius:10,
                                }}
                                type="text"
                                value={name}
                                onChange={handleNameChange}
                                placeholder="Enter Gift Name"
                                required
                            />
                        </Form.Group>
                        <Form.Label>Description </Form.Label>
                        <Form.Control
                            style={{
                                height: 40,

                                borderColor: '#ccc',
                                borderWidth: 1,
                                paddingHorizontal: 8,
                                marginBottom: 16,
                                
                                borderRadius:10,
                            }}
                            type="text"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            placeholder="Enter Description"
                        />
                        <Form.Label>Category <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <div className="selectdoctor">
                                <Select
                                    options={category}
                                    value={selectedCategory}
                                    onChange={handleCategoryChange}
                                    isClearable={true}
                                    styles={{

                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            color: '#ccc' // Change color of the arrow here
                                        })
                                    }}
                                    placeholder="Select Category"
                                />
                            </div>
                        </Form.Group>
                        <Form.Label>Currency <span style={{ color: 'red' }}>*</span></Form.Label>
                        <Form.Group
                            className="mb-3 d-flex w-100"
                            style={{ gap: "15px" }}
                            controlId="formBasicPassword"
                        >
                            <div className="selectdoctor">
                                <Select
                                    options={currency}
                                    value={selectedCurrency}
                                    onChange={handleCurrencyChange}
                                    isClearable={true}
                                    styles={{

                                        dropdownIndicator: (provided) => ({
                                            ...provided,
                                            color: '#ccc' // Change color of the arrow here
                                        })
                                    }}
                                    placeholder="Select Currency"
                                />
                            </div>
                        </Form.Group>
                        <Form.Label>Price </Form.Label>
                        <Form.Control
                            style={{
                                height: 40,

                                borderColor: '#ccc',
                                borderWidth: 1,
                                paddingHorizontal: 8,
                                marginBottom: 16,
                                
                                borderRadius:10,
                            }}
                            type="number"
                            value={price}
                            onChange={(e) => setPrice(e.target.value)}
                            placeholder="Enter Price"
                        />
                        <Form.Label>Sale Price </Form.Label>
                        <Form.Control
                            style={{
                                height: 40,

                                borderColor: '#ccc',
                                borderWidth: 1,
                                paddingHorizontal: 8,
                                marginBottom: 16,
                                
                                borderRadius:10,
                            }}
                            type="number"
                            value={salePrice}
                            onChange={(e) => setSalePrice(e.target.value)}
                            placeholder="Enter Sale Price"
                        />
                        <Form.Label>Quantity </Form.Label>
                        <Form.Control
                            style={{
                                height: 40,

                                borderColor: '#ccc',
                                borderWidth: 1,
                                paddingHorizontal: 8,
                                marginBottom: 16,
                                
                                borderRadius:10,
                            }}
                            type="number"
                            value={quantity}
                            onChange={(e) => setQuantity(e.target.value)}
                            placeholder="Enter Quantity Of Product"
                        />
                    </Form>
                </Modal.Body> : <div style={{display:'grid',placeContent:'center'}}><LoadingComponent /></div>}
                <Modal.Footer>
                    <Button variant="secondary" onClick={handleClose}>
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={operation == 'Add' ? handleSave : handleEditSave}
                    >
                        {operation}
                    </Button>
                </Modal.Footer>
            </Modal>
 <Modal show={showuploader} onHide={handleUploaderClose}>
        <Modal.Header closeButton>
          <Modal.Title>Upload Excel</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <input
              type="file"
              accept=".xlsx, .xls"
              onChange={handleFileUpload}
            />
          </div>
          {fileUploaded && (
  <div>
    <hr />
    {/* Name */}
    <div>
      <label style={{ paddingTop: 10 }} htmlFor="title1">
        Name <span style={{ color: "red" }}>*</span>
      </label>
      <Form.Select
        id="title1"
        name="title1"
        value={columnTitles.title1}
        onChange={handleTitleChange}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%232457C5'%3E%3Cpath d='M14.293 7.293a1 1 0 0 0-1.414 1.414L10 11.414l-2.879-2.88a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right .75rem center",
          backgroundSize: "25px 25px",
        }}
      >
        <option>--Select Data---</option>
        {Object.keys(excelData[0] || {}).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </Form.Select>
    </div>

    {/* Description */}
    <div>
      <label style={{ paddingTop: 10 }} htmlFor="title2">
        Description <span style={{ color: "red" }}>*</span>
      </label>
      <Form.Select
        id="title2"
        name="title2"
        value={columnTitles.title2}
        onChange={handleTitleChange}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%232457C5'%3E%3Cpath d='M14.293 7.293a1 1 0 0 0-1.414 1.414L10 11.414l-2.879-2.88a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right .75rem center",
          backgroundSize: "25px 25px",
        }}
      >
        <option>--Select Data---</option>
        {Object.keys(excelData[0] || {}).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </Form.Select>
    </div>

    {/* Category ID */}
    <div>
      <label style={{ paddingTop: 10 }} htmlFor="title3">
        Category <span style={{ color: "red" }}>*</span>
      </label>
      <Form.Select
        id="title3"
        name="title3"
        value={columnTitles.title3}
        onChange={handleTitleChange}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%232457C5'%3E%3Cpath d='M14.293 7.293a1 1 0 0 0-1.414 1.414L10 11.414l-2.879-2.88a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right .75rem center",
          backgroundSize: "25px 25px",
        }}
      >
        <option>--Select Data---</option>
        {Object.keys(excelData[0] || {}).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </Form.Select>
    </div>

    {/* Price */}
    <div>
      <label style={{ paddingTop: 10 }} htmlFor="title4">
        Price <span style={{ color: "red" }}>*</span>
      </label>
      <Form.Select
        id="title4"
        name="title4"
        value={columnTitles.title4}
        onChange={handleTitleChange}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%232457C5'%3E%3Cpath d='M14.293 7.293a1 1 0 0 0-1.414 1.414L10 11.414l-2.879-2.88a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right .75rem center",
          backgroundSize: "25px 25px",
        }}
      >
        <option>--Select Data---</option>
        {Object.keys(excelData[0] || {}).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </Form.Select>
    </div>

    {/* Sale Price */}
    <div>
      <label style={{ paddingTop: 10 }} htmlFor="title5">
        Sale Price <span style={{ color: "red" }}>*</span>
      </label>
      <Form.Select
        id="title5"
        name="title5"
        value={columnTitles.title5}
        onChange={handleTitleChange}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%232457C5'%3E%3Cpath d='M14.293 7.293a1 1 0 0 0-1.414 1.414L10 11.414l-2.879-2.88a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right .75rem center",
          backgroundSize: "25px 25px",
        }}
      >
        <option>--Select Data---</option>
        {Object.keys(excelData[0] || {}).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </Form.Select>
    </div>

    {/* Quantity */}
    <div>
      <label style={{ paddingTop: 10 }} htmlFor="title6">
        Quantity <span style={{ color: "red" }}>*</span>
      </label>
      <Form.Select
        id="title6"
        name="title6"
        value={columnTitles.title6}
        onChange={handleTitleChange}
        style={{
          backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%232457C5'%3E%3Cpath d='M14.293 7.293a1 1 0 0 0-1.414 1.414L10 11.414l-2.879-2.88a1 1 0 1 0-1.414 1.414l3.5 3.5a1 1 0 0 0 1.414 0l3.5-3.5a1 1 0 0 0 0-1.414z'/%3E%3C/svg%3E")`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "right .75rem center",
          backgroundSize: "25px 25px",
        }}
      >
        <option>--Select Data---</option>
        {Object.keys(excelData[0] || {}).map((key) => (
          <option key={key} value={key}>
            {key}
          </option>
        ))}
      </Form.Select>
    </div>
  </div>
)}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleUploaderClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleAddData} disabled={!fileUploaded}>
            Add Data
          </Button>
        </Modal.Footer>
      </Modal>
        </Container>
    )
}

export default GiftMaster
